import React from 'react';
import { IAccountData } from '../../../../Layout/Account/Data';
import { cn } from '../../../../../../utils/styles';
import Checkbox from '../../../../../../components/Common/UI/Checkbox';

interface IAccounts {
  data: IAccountData[];
  selectable?: boolean;
  selectedAccounts?: string[];
  onAccountSelect?: (accountNumber: string, checked: boolean) => void;
}

function Accounts({ data, selectable = false, selectedAccounts = [], onAccountSelect }: IAccounts) {
  const allAccounts = data.flatMap(accData =>
    accData.accounts.map(account => ({
      ...account,
      type: accData.type,
      color: accData.color,
      label: accData.label,
    })),
  );

  if (allAccounts.length === 0) return null;

  return (
    <div className="grid gap-4 sm:grid-cols-2 w-1/2">
      {allAccounts.map(account => {
        const isSelected = selectedAccounts.includes(account.number);

        return (
          <button
            key={account.number}
            type="button"
            className={cn(
              'flex items-center gap-3 p-4 rounded-lg border bg-white cursor-pointer transition-all text-left w-full',
              'hover:bg-gray-50 border-l-[4px]',
              isSelected && 'bg-gray-50',
            )}
            style={{ borderLeftColor: account.color }}
            onClick={() => onAccountSelect?.(account.number, !isSelected)}
            disabled={!selectable}
          >
            {selectable && (
              <Checkbox
                checked={isSelected}
                onCheckedChange={checked => onAccountSelect?.(account.number, checked as boolean)}
                onClick={e => e.stopPropagation()}
              />
            )}
            <div className="flex-1">
              <div className="font-medium text-base text-gray-900">{account.number}</div>
              <div className="text-sm text-gray-500">{account.label}</div>{' '}
            </div>
          </button>
        );
      })}
    </div>
  );
}

Accounts.defaultProps = {
  selectable: false,
  selectedAccounts: [],
  onAccountSelect: undefined,
};

export default Accounts;
